import { Box, Grid, Stack } from '@chakra-ui/react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppSettings } from '@/appSettings'
import { DocumentsList } from '@/components/Documents/DocumentsList'
import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { usePartner } from '@/context/PartnerContext'
import { PageWrapper } from '@/layouts/components/PageWrapper'

const baseUrl = AppSettings.baseUrl + '/docs/'

// Pouze JAP
export const Documents = () => {
  const { currentPartner } = usePartner()
  const navigate = useNavigate()

  useEffect(() => {
    if (currentPartner?.partner !== 'Jap')
      navigate('/')
  }, [currentPartner?.partner])

  return (currentPartner?.partner === 'Jap' &&
        <PageWrapper
          header={<DashboardHeader title={(
            <>
              <Stack color='white' alignItems='center'>
                <Box>Dokumenty ke stažení</Box>
              </Stack>
            </>
          )}
          />}
          mainProps={{ sx: { pt: 8, gap: 4, display: 'grid' } }}
        >
          <Grid
            // gap={8}
            sx={{
              backgroundColor: 'white',
              p: 6
            }}
            templateColumns='1fr 1fr 1fr'
          >
            <DocumentsList items={[
              {
                url: baseUrl + 'sjednani_pojisteni_dle_pojistovny_a_klienta.pdf',
                name: 'Sjednání pojištění dle pojišťovny a klienta',
                documentType: 'pdf'
              },
              {
                url: baseUrl + 'zaznam_o_dopravni_nehode.pdf',
                name: 'Záznam o dopravní nehodě',
                documentType: 'pdf'
              },
            ]} />
            <DocumentsList items={[
              {
                url: baseUrl + 'vypoved_emailem_vzory_kontakty.docx',
                name: 'Výpověď - emailem vzory kontakty',
                documentType: 'doc'
              },
              {
                url: baseUrl + 'vypoved_prodej_zmena_pojistny_zajem.doc',
                name: 'Výpověď - Zánik pojistného zájmu (prodej, změna vl.)',
                documentType: 'doc'
              },
              {
                url: baseUrl + 'vypoved_konec_pojistneho_obdobi.doc',
                name: 'Výpověď - konec pojistného období',
                documentType: 'doc'
              },
              {
                url: baseUrl + 'vypoved_nahrada.doc',
                name: 'Výpověď - náhrada',
                documentType: 'doc'
              },
              {
                url: baseUrl + 'vypoved_ostatni_duvody.doc',
                name: 'Výpověď - ukončení ostatní',
                documentType: 'doc'
              },
              {
                url: baseUrl + 'vypoved_odmitnuti_navrhu.doc',
                name: 'Odmítnutí návrhu',
                documentType: 'doc'
              },
            ]} />
            <DocumentsList items={[
              {
                url: baseUrl + 'kontaktni_udaje_zmena_zadost.doc',
                name: 'Změna kontaktních údajů',
                documentType: 'doc'
              },
              {
                url: baseUrl + 'Formular_pro_nabidku_VOZ.xlsx',
                name: 'Formulář pro nabídku pojištění - Vozidla',
                documentType: 'xlsx'
              },
              {
                url: baseUrl + 'Formular_pro_nabidku_MAJETEK.xlsx',
                name: 'Formulář pro nabídku pojištění - Majetek',
                documentType: 'xlsx'
              },
              {
                url: baseUrl + 'Formular_pro_nabidku_STROJ.xlsx',
                name: 'Formulář pro nabídku pojištění - Stroje',
                documentType: 'xlsx'
              },
            ]} />
          </Grid>
        </PageWrapper >
  )
}